export default __webpack_public_path__ + "static/media/037-pets.8d572a95.svg";